import apiClient from './apiClient'


const getEventCategories = (tenant) => {
  return apiClient.get(`/${tenant}/EventCategory`)
}

const getEventCategory = (tenant, id) => {
  return apiClient.get(`/${tenant}/EventCategory/${id}`)
}

const getRelations = (tenant, id) => {
  return apiClient.get(`/${tenant}/EventCategory/${id}/Relations`)
}

const createEventCategory = (tenant, eventCategory) => {
  return apiClient.post(`/${tenant}/EventCategory`, eventCategory)
}

const updateEventCategory = (tenant, id, eventCategory) => {
  return apiClient.put(`/${tenant}/EventCategory/${id}`, eventCategory)
}

const deleteEventCategory = (tenant, id) => {
  return apiClient.delete(`/${tenant}/EventCategory/${id}`)
}


export default {
  getEventCategories,
  getEventCategory,
  getRelations,
  createEventCategory,
  updateEventCategory,
  deleteEventCategory
}
